import React from "react";
import { Spinner, SpinnerSize, Stack, Text } from "sprint-common-web";

interface AppLoaderProps {
    message: string;
}

export const AppLoader: React.VFC<AppLoaderProps> = ({ message }: AppLoaderProps) => {
    return (
        <Stack
            tokens={{ childrenGap: 20 }}
            styles={{
                root: {
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100vh",
                    display: "flex",
                    flexDirection: "column"
                }
            }}
        >
            <Spinner size={SpinnerSize.large} />
            <Text>{message}</Text>
        </Stack>
    );
};
